import messages from './messages.tsx';

export const errorFlag = () => ({
	type: 'error',
	...messages,
});
